import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { trackPage } from "./tracking";

export const usePageTracker = () => {
  const { bibleId } = useParams<{ bibleId?: string }>();
  const { pathname, search } = useLocation();

  useEffect(() => {
    const options = {} as any;
    if (bibleId) options.dimension1 = bibleId;
    trackPage(pathname, options);
  }, [pathname, search, bibleId]);
};

export function withPageTracker<Props>(C: React.ComponentType<Props>) {
  return (props: Props) => {
    usePageTracker();
    return <C {...props} />;
  };
}
